import { createRoute, redirect } from '@tanstack/react-router';
import { rotaRaiz } from './raiz';
import { garantirSessao } from '../api';

/**
 * A conversa de uma sessão mora no painel da direita do workspace.
 *
 * Manter uma página cheia em paralelo faria duas telas para a mesma coisa, com
 * duas cópias do replay para manter em pé. No celular o próprio workspace já
 * troca para o layout de abas, então este endereço serve os dois casos.
 */
export const rotaSessao = createRoute({
  getParentRoute: () => rotaRaiz,
  path: '/sessoes/$id',
  beforeLoad: async ({ params }) => {
    if (!(await garantirSessao())) throw redirect({ to: '/entrar' });
    throw redirect({ to: '/', search: { s: params.id, lado: 'sessoes' } });
  },
});
